module.exports = __webpack_public_path__ + "img/Irish.153aaaaf.svg";